export default __webpack_public_path__ + "static/media/packing.841b764e.jpg";